import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "../LanguageSwitcher";
import { ProjectDeveloper } from "@/types";

interface DashboardHeaderProps {
  customerLogo?: string;
  customerName?: string;
  customerColor?: string;
  projectDeveloper?: ProjectDeveloper;
  showProjectDeveloper?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  customerLogo,
  customerName,
  customerColor = "#00383c",
  projectDeveloper,
  showProjectDeveloper = true,
}) => {
  const { t } = useLanguage();

  return (
    <header className="w-full border-b bg-white md:sticky md:top-0 md:z-50">
      {/* Colored bar at the very top */}
      <div
        className="h-1 w-full"
        style={{ backgroundColor: customerColor }}
      ></div>

      <div className="container mx-auto flex items-center justify-between px-4 py-3 md:h-20 md:py-0">
        {/* Left side with logo and title */}
        <div className="flex flex-col items-center md:flex-row md:items-center gap-3 w-full">
          {customerLogo && (
            <img
              src={customerLogo}
              alt={`${customerName || "Company"} logo`}
              className="h-10 w-auto object-contain mt-2 md:mt-0"
              onError={(e) => {
                e.currentTarget.src =
                  "https://cdn.tree.ly/assets/v3/logo_full_green.svg";
              }}
            />
          )}
          <div className="text-center md:text-left">
            <h1 className="text-sm md:text-xl font-bold">
              {customerName}'s {t("dashboard.title")}
            </h1>
          </div>

          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
        </div>

        {showProjectDeveloper && (
          <div className="flex items-center gap-3 whitespace-nowrap">
            <span className="hidden sm:flex items-center text-sm text-gray-500">
              {t("dashboard.projectsCooperation")}
              <a
                href={projectDeveloper?.websiteUrl || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block ml-2"
              >
                <img
                  src={projectDeveloper?.logoUrl}
                  alt="Project Developer logo"
                  className="h-10 w-auto"
                />
              </a>
            </span>
          </div>
        )}
      </div>
    </header>
  );
};

export default DashboardHeader;
